import validators from '../../utils/validators';

class HealthContent {
  /**
   * @param data
   */
  constructor(data) {
    const properties = {
      id: (v) => validators.isNotEmptyString(v),
      health: (v) => validators.isNotEmptyString(v),
      text: (v) => validators.isStringOrNull(v),
      image: (v) => validators.isStringOrNull(v),
      sort: (v) => validators.isNumber(v),
    };

    for (const property of Object.keys(properties)) {
      if (properties[property](data[property]) !== true) {
        throw new Error(`Invalid HealthContent property ${property} "${data[property]}" in ${data.id}`);
      }

      this[property] = data[property];
    }
  }
}

export default HealthContent;
